const header = document.querySelector('#header');
const toggleBtn = document.querySelector('#toggle');
const liBtn = document.querySelectorAll('.header__innerNavList li a');
const liBtnArray = [...liBtn];
const headerbg = document.querySelectorAll(".header__bg")[0]
// Nav Fixed

toggleBtn.addEventListener('click', () => {
  header.classList.toggle('is-open');
});

liBtnArray.forEach((clickEvent) => {
  clickEvent.addEventListener('click', () => {
    header.classList.toggle('is-open');
  });
})

headerbg.addEventListener("click",()=>{
  header.classList.remove('is-open');
})

//スムーズスクロール
// const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
//   for (let i = 0; i < smoothScrollTrigger.length; i++){
//     smoothScrollTrigger[i].addEventListener('click', (e) => {
//       e.preventDefault();
//       let href = smoothScrollTrigger[i].getAttribute('href');
//        let targetElement = document.getElementById(href.replace('#', ''));
//       const rect = targetElement.getBoundingClientRect().top;
//       const offset = window.pageYOffset;
//       const gap = 0;
//       const target = rect + offset - gap;
//       window.scrollTo({
//         top: target,
//         behavior: 'smooth',
//       });
//     });
// }

import SmoothScroll from "smooth-scroll"

let smoption = {
  updateURL: false,
  speed: 60,
  easing: 'linear'
}

let scroll = new SmoothScroll('a[href*="#"]', smoption);